import { map } from 'lodash';

class TreatmentListController {

    constructor($rootScope, $stateParams, $scope, $state, $timeout, treatmentsService, messageService, access, configService) {
        this.$scope = $scope;
        this.$state = $state;
        this.treatmentsService = treatmentsService;
        this.messageService = messageService;
        this.access = access;
        this.configService = configService;
        this.$stateParams = $stateParams;
        this.$rootScope = $rootScope;
        $scope.treeOptions = {
            dropped: function (sourceNodeScope) {
                $timeout(() => sourceNodeScope.source.nodesScope.$parent.$parent.$ctrl.saveStructure());
            }
        };
    }

    $onInit () {
        this.filtertext = this.$stateParams.filtertext || null;
        if (this.filtertext) {
            this.isFiltered = true;
        }

        if (this.treatments) {
            this.activeTab = 'list';
        }

        this.updatePaging();
        this.$scope.$watch(
            function (scope) {
                return scope.current_page;
            },
            function (newVal, oldVal, scope) {
                if (newVal !== oldVal) {
                    if (scope.$ctrl.filtertext && scope.$ctrl.filtertype && scope.$ctrl.isFiltered) {
                        scope.$ctrl.treatments = undefined;
                        scope.$ctrl.treatmentsService.search(scope.$ctrl.filtertype, scope.$ctrl.filtertext, newVal).then(response => {
                            scope.$ctrl.treatments = response;
                            scope.$ctrl.loading = false;
                        });
                    }
                    else {
                        scope.$ctrl.treatmentsService.findAll(newVal, scope.per_page)
                            .then(list => scope.$ctrl.treatments = list);
                    }
                }
            }
        );
    }

    updatePaging () {
        this.$scope.per_page = this.treatments.per_page;
        this.$scope.current_page = this.treatments.current_page;
        this.$scope.total = this.treatments.total;
    }

    onDelete (treatment) {
        return this.treatmentsService.delete(treatment.id)
            .then(() => {
                this.messageService.success(`The treatment <strong>${treatment.name}</strong> was successfully deleted.`);
                this.messageService.push();
            })
            .catch((error) => {
                this.messageService.failure(`The treatment <strong>${treatment.name}</strong> could not be successfully deleted: ${error.statusText}`);
                this.messageService.push();
            })
            .then(() => {
                let page = this.treatments.current_page;
                this.treatments = [];
                this.loading = true;
                return this.treatmentsService.findAll(page).then(response => {
                    this.treatments = response;
                    this.loading = false;
                });
            });
    }

    saveStructure () {
        this.treatmentsService.reconstruct(map(this.treatments.tree, 'id'))
            .then(() => {
                this.messageService.success(`This event order has been successfully saved.`);
                this.messageService.push();
                this.messageService.autoClear();
            })
            .catch(() => {
                this.messageService.failure(`This event order could not be successfully saved: ${error.statusText}`);
                this.messageService.push();
            });
    }

    toggleActive (treatment) {
        this.treatmentsService.toggleActive(treatment.id)
            .catch(
                (error) => {
                    this.messageService.failure(`The treatment <strong>${treatment.name}</strong> could not be successfully toggled (active): ${error.statusText}`);
                    this.messageService.push();
                }
            )
            .then(
                () => treatment.status = !treatment.status
            );
    }

    toggleVisible (treatment) {
        this.treatmentsService.toggleVisible(treatment.id)
            .catch(
                (error) => {
                    this.messageService.failure(`The treatment <strong>${treatment.name}</strong> could not be successfully toggled (visibility): ${error.statusText}`);
                    this.messageService.push();
                }
            )
            .then(
                () => treatment.secret = !treatment.secret
            );
    }

    filter () {
        if (!this.loading && this.filtertext) {
            this.startFilter();
            this.treatmentsService.search(this.filtertype, this.filtertext).then(response => {
                this.isFiltered = true;
                this.endFilter(response);
            });
        }
    }

    clearfilter () {
        if (this.isFiltered) {
            this.startFilter();
            this.treatmentsService.findAll(1, 20).then(response => {
                this.isFiltered = false;
                this.endFilter(response);
            });
        }
    }

    filtertypeChange () {
        switch (this.filtertype) {
            case 'cat':
                this.filtertext = this.categories.flat[0].id;
                break;
            case 'status':
                this.filtertext = '1';
                break;
            case 'secret':
                this.filtertext = '0';
                break;
            default:
                this.filtertext = '';
                break;
        }
    }

    startFilter () {
        this.treatments = undefined;
        this.loading = true;
    }

    endFilter (response) {
        this.treatments = response;
        this.updatePaging();
        this.loading = false;
    }

    updatePriority (event) {
        if (!event || event.priority === '' || event.priority > 999 || event.priority === undefined){
            return false;
        }
        this.updateWait(event);
    }

    updateWait(item){
        if (item.priority.match(/[^0-9]+/g)) return;
        item.updating = false;
        clearTimeout(item.trigger);
        item.trigger = setTimeout(() => {this.trigger(item);}, 1000);
    }
    
    update(item){
        this.trigger(item);
    }
    
    trigger(item){
        item.trigger = undefined;
        item.updating = true;
    
        this.treatmentsService.updatePriority(item).then(() =>{
          item.updating = false;
        });
    }
}

TreatmentListController.$inject = ['$rootScope', '$stateParams', '$scope', '$state', '$timeout', 'treatmentsService', 'messageService', 'access', 'configService'];

export default TreatmentListController;



// WEBPACK FOOTER //
// ./frontend/admin/app/modules/treatment/controllers/treatment.list.controller.js